import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/constants';

import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import { Asset } from 'src/app/shared/model/itsm';

@Component({
  selector: 'app-assetdashboard',
  templateUrl: './assetdashboard.component.html',
  styleUrls: ['./assetdashboard.component.scss']
})
export class AssetDashboardComponent implements OnInit {
  // pagination
  perPage = constants.recordsPerPage.cases;
  currentPage: number;

  // data
  assets: Asset[];
  allAssets: Asset[];
  subsetAssets: Asset[];
  assetsLoaded: boolean;
  includeInactive: boolean;
  vendors: string[];

  //search
  source: string;
  assetName: string;
  assetSerialNumber: string;
  assetVendor: string;
  sortedBy: string;
  sortedOrder: number;

  // user prefs
  flags: any[];
  flagRefs: string[];
  flaggingRef: string //used to stop the flapping of flags whilst waiting for update to complete

  // view
  viewType: string;
  page: string;

  datepipe: DatePipe = new DatePipe('en-GB')

  // initial page to load
  loadpage: string;

  constructor(  private itsmService: ItsmService,
                private errorService: ErrorService,
                private userprefService: UserPreferenceService
              ) { }


  ngOnInit() {
    // initialise
    this.currentPage = 1;
    this.page = 'assets';
    this.includeInactive = false;

    // load the flags signals from the user preferences
    this.refreshAssetUserPrefs();

    // load assets
    this.loadAssets();
  }

  /**
   * Refresh the local flagRefs and viewType variable from user preferences
   */
  refreshAssetUserPrefs(): Promise<void>{
    // load the flagged signals from user preferences
    return new Promise((resolve,reject) => {
      this.userprefService.getUserPreferences()
        .then(res => {
          if(res.flags && res.flags.asset){
            this.flagRefs = res.flags.asset;
          }else{
            this.flagRefs = [];
          }
          if(res.assetViewType){
            this.viewType = res.assetViewType;
          }else{
            this.viewType = 'list';
          }
          resolve();
        })
        .catch(err => reject(err));
    });
  }

  onPageChange($event){
    this.assetsLoaded = false;
    this.subsetAssets = this.assets.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);  
    this.assetsLoaded = true;
  }

  /**
   * Add a case reference to the user's preferences so they can flag cases
   * @param caseRef 
   */
  flag(assetRef: string) {
    // note which ref is being processed so we can stop user double clicking
    this.flaggingRef = assetRef;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateFlags(constants.local.flags.assets, assetRef, this.flagRefs.includes(assetRef))
      .then(res => {
        this.refreshAssetUserPrefs()
          .then(res => {
            this.flaggingRef = undefined;
          })
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Toggle between grid/list view
   * @param view 
   */
  changeViewType(view: string){
    // set local variable to determine what view the user is using
    this.viewType = view;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateSingle(constants.local.views.asset, view)
      .then(res => {
        this.refreshAssetUserPrefs()
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Return all the assets
   * TODO may need to paginate this so we dont load too much. Depends on SF api performance
   */
  loadAssets() {
    this.assetsLoaded = false;

    this.itsmService.getCachedAssets()
      .then(res => {
          this.allAssets = res;

          this.vendors = [...new Set(this.allAssets.map(item => item.vendor))].sort(function(a, b){
            if(a < b) { return -1; }
            if(a > b) { return 1; }
            return 0;
          });

          this.assets = this.allAssets;

          if(!this.includeInactive){
            this.assets = this.allAssets.filter(a => a.active === 'true');
          }
          this.assets.map(a => {
            if (a.model && (a.model != a.name)) {
              a.name = a.model + " - " + a.name;
            }
          });
          this.subsetAssets = this.assets.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);  
          this.assetsLoaded = true;
      })
      .catch(err => {
        this.errorService.handlerError(err);
      })
  }

  sortAssets(field: string){
    this.currentPage = 1;
    if(this.sortedBy === field){
      if(this.sortedOrder == -1) {
        this.sortedOrder = 1;
        this.assets.sort(function(a, b){
          if(a[field] < b[field]) { return 1; }
          if(a[field] > b[field]) { return -1; }
          return 0;
        });
      }else{
        this.sortedOrder = -1;
        this.assets.sort(function(a, b){
          if(a[field] < b[field]) { return -1; }
          if(a[field] > b[field]) { return 1; }
          return 0;
        });
      }
    }else{
      this.sortedBy = field;
      this.sortedOrder = 1;
      this.assets.sort(function(a, b){
        if(a[field] < b[field]) { return -1; }
        if(a[field] > b[field]) { return 1; }
        return 0;
      });
    }
    this.subsetAssets = this.assets.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);  
  }

  toggleInactive(){
    this.includeInactive = !this.includeInactive;
    this.loadAssets();
  }

  /** 
   * Load flagged assets
   */
  loadFlagged(){
    this.currentPage = 1;
    this.page = 'flagged';
    this.assetsLoaded = false;
    this.assets = this.allAssets.filter(a => this.flagRefs.includes(a.id));
    this.subsetAssets = this.assets.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);
    this.assetsLoaded = true;
  }

  search(){
    delete this.assets;
    this.page = 'assets';
    this.currentPage = 1;
    this.assetsLoaded = false;
    this.assets = this.allAssets;
    if(this.source){
      this.assets = this.assets.filter(a => a.source == this.source);
    }
    if(this.assetName){
      this.assets = this.assets.filter(a => a.name.toLowerCase().indexOf(this.assetName.toLowerCase()) >= 0 );
    }
    if(this.assetVendor){
      this.assets = this.assets.filter(a => a.vendor == this.assetVendor);
    }
    if(this.assetSerialNumber){
      this.assets = this.assets.filter(a => a.serialNumber && a.serialNumber.toLowerCase().indexOf(this.assetSerialNumber.toLowerCase()) >= 0);
    }
    this.subsetAssets = this.assets.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);  
    this.assetsLoaded = true;
  }

  reset(){
    delete this.source;
    delete this.assetName;
    delete this.assetSerialNumber;
    delete this.assetVendor;
    this.loadAssets();
  }

  /**
   * Error handling forwarder, only not going direct so 
   * it allows us to add context within this module
   * @param err 
   */
  private handlerError(err){
    this.errorService.handlerError(err);
  }
}
